/*
 * av-flavor-swap.js — no-reload flavor sibling swap (WP1)
 * -----------------------------------------------------------------------------
 * Progressively enhances the flavor tiles (real <a> anchors, server-rendered with
 * locale-correct product.url) into in-place swaps of #av-buybox via the Section
 * Rendering API (?section_id=). Pricing / selling plans / gallery / copy are all
 * SERVER-rendered for the sibling product — nothing is recomputed client-side.
 *
 * Requires window.AvBuyBox (av-buybox.js) for teardown/mount. Any failure — no
 * controller, no #av-buybox in the response, network error — falls back to a
 * normal full navigation, so the tiles always work (and work with JS disabled).
 */
(function () {
  'use strict';
  if (window.__avFlavorSwapBound) return;
  window.__avFlavorSwapBound = true;

  var cache = {};   // href -> Promise<string html>
  var busy = false;

  function root() { return document.getElementById('av-buybox'); }
  function sectionId() { var r = root(); return r ? r.getAttribute('data-bb') : null; }
  function cfgOf(node) {
    var el = node && node.querySelector('[data-av-config]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function sectionUrl(href) {
    var id = sectionId();
    if (!id) return null;
    return href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
  }
  function fetchSection(href) {
    if (cache[href]) return cache[href];
    var url = sectionUrl(href);
    if (!url) return Promise.reject(new Error('no section id'));
    var p = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
    cache[href] = p;
    p.catch(function () { delete cache[href]; }); // allow retry after a failed prefetch/fetch
    return p;
  }
  function prefetch(href) { if (href && !cache[href]) fetchSection(href).catch(function () {}); }
  /* Shared with av-buybox.js, which pulls Strawberry's gallery for Berry Mix from the
     same section HTML the Strawberry tile prefetches: one request, one cache. */
  window.AvFlavorSwap = { fetchSection: fetchSection };

  function parseFresh(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.getElementById('av-buybox');
  }

  /* Requirement 4: fire ViewContent for the swapped-in product. There is no pixel
     in the theme (it's injected via content_for_header), so feature-detect every
     path. Shape mirrors Shopify's default product ViewContent; confirm against the
     live page-load event at Gate 2. */
  function fireViewContent(cfg) {
    if (!cfg || cfg.variantId == null) return;
    var content = { content_ids: [String(cfg.variantId)], content_type: 'product' };
    if (cfg.value != null) content.value = cfg.value;
    if (cfg.currency) content.currency = cfg.currency;
    try { if (typeof window.fbq === 'function') window.fbq('track', 'ViewContent', content); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'ViewContent' }, content)); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('product_viewed', { productVariantId: String(cfg.variantId) });
      }
    } catch (e) {}
  }

  function focusCurrentTile(node) {
    var cur = node && node.querySelector('[data-flavor-current]');
    if (cur && cur.focus) { try { cur.focus({ preventScroll: true }); } catch (e) { cur.focus(); } }
  }

  function swap(href) {
    var live = root();
    if (!live) { window.location.href = href; return; }
    if (busy) return; // a swap is already in flight — ignore rapid re-clicks
    busy = true;

    var carry = (live.__avOffer && live.__avOffer.getSelection) ? live.__avOffer.getSelection() : null;
    live.classList.add('is-swapping');
    live.setAttribute('aria-busy', 'true');

    fetchSection(href).then(function (html) {
      var fresh = parseFresh(html);
      if (!fresh) throw new Error('no #av-buybox in response');
      if (window.AvBuyBox && AvBuyBox.teardown) AvBuyBox.teardown(live);
      live.replaceWith(fresh);
      if (window.AvBuyBox && AvBuyBox.mount) AvBuyBox.mount(fresh);
      if (carry && fresh.__avOffer && fresh.__avOffer.applySelection) fresh.__avOffer.applySelection(carry);

      var cfg = cfgOf(fresh);
      try { history.replaceState({ avFlavor: true }, '', href); } catch (e) {}
      if (cfg.pageTitle) document.title = cfg.pageTitle;
      fireViewContent(cfg);
      focusCurrentTile(fresh);

      fresh.classList.remove('is-swapping');
      fresh.removeAttribute('aria-busy');
      busy = false;
    }).catch(function () {
      busy = false;
      window.location.href = href; // graceful fallback: full navigation
    });
  }

  /* Delegated click. Real anchors → modified / middle / non-primary clicks pass
     through to the browser (open in new tab, etc.). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-flavor-tile]');
    if (!a) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var href = a.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    swap(href);
  });

  /* Prefetch on intent (hover / touch / keyboard focus) and once on idle. */
  function intentPrefetch(e) {
    var a = e.target.closest && e.target.closest('a[data-flavor-tile]');
    if (a) prefetch(a.getAttribute('href'));
  }
  document.addEventListener('mouseover', intentPrefetch, { passive: true });
  document.addEventListener('touchstart', intentPrefetch, { passive: true });
  document.addEventListener('focusin', intentPrefetch);

  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
  idle(function () {
    var r = root();
    if (!r) return;
    [].slice.call(r.querySelectorAll('a[data-flavor-tile]')).forEach(function (a) { prefetch(a.getAttribute('href')); });
  });
})();
